import type { GetProductQuery } from "../../../../../graphql/operations";
import { useCachedGql } from "../../../../../hooks/useCachedGql";

export type ProductAnnouncement = NonNullable<
  GetProductQuery["product"]
>["announcement"];

// The announcement embedded in the page (ISR) renders first, so the banner is in the
// HTML and nothing shifts when it appears. Announcements are edited without
// revalidating product pages, so the latest one is fetched (server cache, 5 minutes)
// and replaces it.
export function useProductAnnouncement(
  productId: string,
  initialAnnouncement: ProductAnnouncement,
): ProductAnnouncement {
  const { data } = useCachedGql("getProductAnnouncement", {
    mode: "server",
    ttl: 300,
    variables: { productId },
  });

  return data ? data.product?.announcement : initialAnnouncement;
}
